import WarningIcon from "@mui/icons-material/Warning";
// Local
import { DataTypeImportAll } from "../../Pages/Quickbooks/QuickbooksImportContainer";
import BaseButtonPrimary from "../BaseButtonPrimary";
import StyledMessage from "../StyledMessage";

interface Props {
  selectedDataTypeAll: DataTypeImportAll;
}

/** Import Option: All */
export default function ImportAllContent(props: Props): JSX.Element {
  const styledMessage = (
    <StyledMessage
      type="warning"
      dismissible={false}
      overrideTextAlignment="text-left"
      overrideIconAlignment="self-start"
      overridePadding="px-3 py-2"
    >
      {{
        message: (
          <div className="text-base">
            <p>
              <span className="font-semibold">Import Entire Sets: </span>
              You likely want to import entire datasets if your site is brand
              new and you have just connected Stilt to Quickbooks.
            </p>
            <p>
              If you have no data in Stilt, this is the best way to get started.
            </p>
          </div>
        ),
        icon: <WarningIcon sx={{ fontSize: "1.2rem" }} />,
      }}
    </StyledMessage>
  );

  return (
    <div>
      <StyledMessage
        type="info"
        dismissible={false}
        overrideTextAlignment="text-left"
        overrideIconAlignment="self-start"
        overridePadding="px-3 py-2"
      >
        {{
          message: (
            <div className="text-xl">
              @Harry - "Import Entire Sets" tab has zero functionality right now
            </div>
          ),
        }}
      </StyledMessage>

      {styledMessage}

      {props.selectedDataTypeAll === "all" && (
        <>
          <p>
            TODO: probably something about if their QBO file has a LOT of data,
            importing all at once might time out (or something). and if that
            keeps happening, the suggested route is customers, pbItems,
            invoices, then payments.
          </p>
          <BaseButtonPrimary>Import All Data</BaseButtonPrimary>
        </>
      )}

      {/* <StyledMessage kind="warning">
        <p>
          <strong>Warning:</strong> This action will import all customers from
          Quickbooks.
        </p>
      </StyledMessage> */}
    </div>
  );
}
